<ng-container *ngIf="!isLoggingOut">
  <ng-container *ngIf="isLoggedIn && !isArrivalRoute">
    <router-outlet></router-outlet>
  </ng-container>

  <ng-container *ngIf="!isLoggedIn">
    <router-outlet></router-outlet>
  </ng-container>
</ng-container>
